/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../../ComponentBase';
import ObservableDoubleComponent from '../Observable/ObservableDoubleComponent';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import { ReferenceGroup } from '../ComponentReference/ReferenceGroup';
import { CurrencyUtil } from '../../CurrencyUtil';
import LocalizationComponent from '../../../Localization/LocalizationComponent';
import Currency from '../../../Localization/Currency';

const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.requireComponent(cc.Label)
export default class TopPrizeDisplay extends ComponentBase {

    @property({ visible: true })
    protected creditTopPrize = 0;

    protected denomRef: InjectableComponent<ObservableDoubleComponent>
        = new InjectableComponent<ObservableDoubleComponent>(ReferenceGroup.MainGame, "BetManager.BetDenom");
    private get _denom(): number { return this.denomRef.Value.Value; }
    
    protected localRef: InjectableComponent<LocalizationComponent>
        = new InjectableComponent<LocalizationComponent>();

    private _label: cc.Label = null;

    protected setContexts(): void
    {
        this.denomRef.SetContext(ObservableDoubleComponent);
        this.localRef.SetContext(LocalizationComponent);
    }

    protected onLoad()
    {
        super.onLoad();

        this._label = this.getComponent(cc.Label);
    }

    protected start()
    {
        super.start();

        this.denomRef.Value.OnChanged(this.updateTopPrize);
    }

    protected updateTopPrize = (): void =>
    {
        this._label.string = CurrencyUtil.GetCurrencyString(this.localRef.Value, Currency.ConvertMCToCash(this._denom) * this.creditTopPrize);
    }
}
